import React, { useState } from "react";
import { Button, Modal } from "reactstrap";
import { useDispatch } from "react-redux";
import { responseToaster } from "../../../helperFunctions";
import CustomeButton from "../../../components/Custom/Forms/CustomeButton/CustomeButton";
import CheckBox from "../../../components/Custom/Forms/CheckBox/CheckBox";
import InputField from "../../../components/Custom/Forms/InputField/InputField";
import { blockChargebackCustomer } from "../../../redux/slices/customerDetailsSlice";

const BlockChargebackCustomerModal = (props) => {
    const { blockCustomer, isBlockCustomerId, chargeBackId, onCloseBlockCustomerModal, onGet } = props;

    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const [alsoBlockPayout, setAlsoBlockPayout] = useState(false);
    const [reason, setReason] = useState("");

    const dispatch = useDispatch();

    const onClose = () => {
        setAlsoBlockPayout(false);
        setReason("");
        setIsButtonLoading(false);
        onCloseBlockCustomerModal();
    };

    const Block_customer = async () => {
        try {
            setIsButtonLoading(true);
            let Payload = {
                txnId: isBlockCustomerId,
                reason: reason,
                chargeBackId: chargeBackId,
                blockWithdrawal: alsoBlockPayout ? 1 : 0,
                blockAllCust: isBlockCustomerId === "all" ? 1 : 0,
            };
            let response = await dispatch(blockChargebackCustomer(Payload)).unwrap();
            responseToaster(response);
            if (!!response) {
                onClose();
                onGet();
            }
            setIsButtonLoading(false);
        } catch (err) {
            setIsButtonLoading(false);
        }
    };

    return (
        <Modal isOpen={blockCustomer} toggle={onClose} centered={true}>
            <div className="modal-header">
                <h3 className="modal-title mt-0">Block Customer</h3>
                <i onClick={onClose} className="fa-solid fa-xmark cursor-pointer"></i>
            </div>
            <div className="modal-body">
                <div>
                    <p>Are you sure you want to block customer?</p>
                </div>
                <div className="mb-3">
                    <InputField
                        label="Reason"
                        type="text"
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        placeholder="Enter reason"
                    />
                </div>
                <div className="d-flex">
                    <CheckBox
                        value={alsoBlockPayout}
                        onChange={(e) => {
                            setAlsoBlockPayout(e);
                        }}
                        label="Also block payout?"
                    />
                </div>
            </div>
            <div className="modal-footer">
                <div className="d-flex justify-content-end button-space">
                    <Button className="graybutton" onClick={onClose}>
                        Cancel
                    </Button>
                    <CustomeButton
                        className="submitbutton"
                        onClick={Block_customer}
                        isButtonLoading={isButtonLoading}
                        disabled={reason === ""}
                    >
                        Submit
                    </CustomeButton>
                </div>
            </div>
        </Modal>
    );
};

export default BlockChargebackCustomerModal;
